import { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { useT } from '../../i18n/useT'
import LocationAddressInput from './LocationAddressInput'

export default function TrafficAlertModal({ initialData, onSave, onClose }) {
  const t = useT()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState({
    originAddr: initialData?.originAddr || '',
    originLat: initialData?.originLat || null,
    originLon: initialData?.originLon || null,
    destAddr: initialData?.destAddr || '',
    destLat: initialData?.destLat || null,
    destLon: initialData?.destLon || null,
  })

  const handleOriginChange = (addr, lat, lon) => {
    setForm((f) => ({ ...f, originAddr: addr, originLat: lat, originLon: lon }))
  }

  const handleDestChange = (addr, lat, lon) => {
    setForm((f) => ({ ...f, destAddr: addr, destLat: lat, destLon: lon }))
  }

  const handleSave = async () => {
    const hasLocation = form.originLat && form.destLat
    if (!hasLocation) {
      alert('Seleziona sia l\'origine che la destinazione')
      return
    }
    setSaving(true)
    try {
      await onSave(hasLocation ? form : null)
      setSaving(false)
      onClose()
    } catch (err) {
      console.error('Traffic alert save error:', err)
      setSaving(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', borderBottom: '1px solid var(--border)' }}>
          <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>📍 {t('traffic_alert_label')}</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <X size={24} />
          </button>
        </div>

        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <LocationAddressInput
            label={t('traffic_origin_label')}
            value={form.originAddr}
            onChange={handleOriginChange}
          />
          <LocationAddressInput
            label={t('traffic_dest_label')}
            value={form.destAddr}
            onChange={handleDestChange}
          />

          <button
            onClick={handleSave}
            disabled={saving}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            {saving ? 'Salvataggio...' : 'Salva'}
          </button>

          <button
            onClick={onClose}
            className="btn btn-ghost"
            style={{ width: '100%' }}
          >
            Annulla
          </button>
        </div>
      </div>
    </div>
  )
}
